const ProductList = () => import('../../pages/products/ProductList');

export default [
  // Cracker Banana
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-cracker-banana',
    name: 'cracker-banana-stamps',
    component: ProductList,
    props: {
      title: 'Set de tampons alphabet Cracker Banana',
      description:
        "Personnalise tes créations ultra facilement avec le set de tampons alphabet Cracker Banana ! <br/> Avec ses lettres manuscrites, fun mais épurées, la police d'écriture Cracker Banana s’adaptera à un grand nombre de styles et de situations.",
      tags: ['set-tampon-alphabet-cracker-banana'],
      articles: [
        {
          src: require('../../../public/img/materiel-creatif/cracker-banana/set-complet-cracker-banana.jpg'),
          name: 'Cracker Banana',
          variant: 'Set complet',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-cracker-banana/set-complet-cracker-banana',
          highlight: true,
        },
        {
          src: require('../../../public/img/materiel-creatif/cracker-banana/cracker-banana-majuscules.jpg'),
          name: 'Cracker Banana',
          variant: 'Jeu de majuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-cracker-banana/majuscules-cracker-banana',
        },
        {
          src: require('../../../public/img/materiel-creatif/cracker-banana/cracker-banana-minuscules.jpg'),
          name: 'Cracker Banana',
          variant: 'Jeu de minuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-cracker-banana/minuscules-cracker-banana',
        },
        {
          src: require('../../../public/img/materiel-creatif/cracker-banana/cracker-banana-speciaux.jpg'),
          name: 'Cracker Banana',
          variant: 'Caractères spéciaux & Chiffres',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-cracker-banana/speciaux-chiffres-cracker-banana',
        },
        {
          src: require('../../../public/img/materiel-creatif/accessoires/vignette-accessoires.jpg'),
          name: '',
          variant: 'Accessoires',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires',
        },
      ],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-cracker-banana/set-complet-cracker-banana',
    name: 'full-set-cracker-banana',
    component: () =>
      import('../../pages/products/creative/CrackerBanana/FullSet'),
    props: {
      src: require('../../../public/img/materiel-creatif/cracker-banana/set-complet-cracker-banana.jpg'),
      type: 'Set complet Cracker Banana',
      hiddenType: 'cracker-banana-stamps',
      description:
        'Un set complet se compose d’1 jeu de majuscules, 1 jeu de minuscules et 1 jeu de caractères spéciaux et chiffres.<br />Entre 110 et 125 caractères accompagnés de leurs plateaux de rangement.<br />Plusieurs lettres sont déjà en double mais n’hésite pas à doubler tout le jeu de minuscules et/ou majuscules pour obtenir un set ultra complet.<br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-cracker-banana'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-cracker-banana/majuscules-cracker-banana',
    name: 'uppercase-cracker-banana',
    component: () =>
      import('../../pages/products/creative/CrackerBanana/Uppercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/cracker-banana/cracker-banana-majuscules.jpg'),
      type: 'Jeu de majuscules Cracker Banana',
      hiddenType: 'cracker-banana-stamps',
      description:
        'Un jeu de majuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-cracker-banana'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-cracker-banana/minuscules-cracker-banana',
    name: 'lowercase-cracker-banana',
    component: () =>
      import('../../pages/products/creative/CrackerBanana/Lowercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/cracker-banana/cracker-banana-minuscules.jpg'),
      type: 'Jeu de minuscules Cracker Banana',
      hiddenType: 'cracker-banana-stamps',
      description:
        "Un jeu de minuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.",
      tags: ['set-tampon-alphabet-cracker-banana'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-cracker-banana/speciaux-chiffres-cracker-banana',
    name: 'specials-numbers-cracker-banana',
    component: () =>
      import('../../pages/products/creative/CrackerBanana/Special'),
    props: {
      src: require('../../../public/img/materiel-creatif/cracker-banana/cracker-banana-speciaux.jpg'),
      type: 'Caractères spéciaux et chiffres Cracker Banana',
      hiddenType: 'cracker-banana-stamps',
      description:
        'Un jeu de caractères spéciaux et chiffres comporte : 11 caractères accentués, 11 éléments de ponctuation, 2x les chiffres de 0 à 9 et même un petit cœur. <br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-cracker-banana'],
    },
  },
];
